"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpErrorCodes = exports.ApiError = void 0;
var ApiError;
(function (ApiError) {
    ApiError["NETWORK_ERROR"] = "NETWORK_ERROR";
    ApiError["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ApiError["CORS_ERROR"] = "CORS_ERROR";
})(ApiError = exports.ApiError || (exports.ApiError = {}));
exports.HttpErrorCodes = {
    400: "BAD_REQUEST",
    401: "UNAUTHORIZED",
    402: "PAYMENT_REQUIRED",
    403: "FORBIDDEN",
    404: "NOT_FOUND",
    405: "METHOD_NOT_ALLOWED",
    406: "NOT_ACCEPTABLE",
    407: "PROXY_AUTHENTICATION_REQUIRED",
    408: "REQUEST_TIMEOUT",
    409: "CONFLICT",
    410: "GONE",
    411: "LENGTH_REQUIRED",
    412: "PRECONDITION_FAILED",
    413: "PAYLOAD_TOO_LARGE",
    414: "URI_TOO_LONG",
    415: "UNSUPPORTED_MEDIA_TYPE",
    416: "RANGE_NOT_SATISFIABLE",
    417: "EXPECTATION_FAILED",
    422: "UNPROCESSABLE_ENTITY",
    425: "TOO_EARLY",
    426: "UPGRADE_REQUIRED",
    428: "PRECONDITION_REQUIRED",
    429: "TOO_MANY_REQUESTS",
    431: "REQUEST_HEADER_FIELDS_TOO_LARGE",
    451: "UNAVAILABLE_FOR_LEGAL_REASONS",
    500: "INTERNAL_SERVER_ERROR",
    501: "NOT_IMPLEMENTED",
    502: "BAD_GATEWAY",
    503: "SERVICE_UNAVAILABLE",
    504: "GATEWAY_TIMEOUT",
    505: "HTTP_VERSION_NOT_SUPPORTED",
    506: "VARIANT_ALSO_NEGOTIATES",
    507: "INSUFFICIENT_STORAGE",
    508: "LOOP_DETECTED",
    509: "BANDWIDTH_LIMIT_EXCEEDED",
    510: "NOT_EXTENDED",
    511: "NETWORK_AUTHENTICATION_REQUIRED",
};
//# sourceMappingURL=ApiError.js.map